import { Fragment } from 'react'

import { faCheck, faCog, faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button } from '@material-ui/core'

import UserAware from 'components/UserAware'

type ActionsCellProps = {
  record: any
  onEdit: (record: any, isReviewingNewUser: boolean) => void
  onDelete: (record: any) => void
  onRolesEdit: (record: any) => void
  isUserPermitted?: boolean
}

const ActionsCell = ({ record, onEdit, onDelete, onRolesEdit, isUserPermitted }: ActionsCellProps) => {
  if (isUserPermitted && record.NeedsApproval) {
    return (
      <Button
        color="primary"
        variant="outlined"
        onClick={() => onEdit(record, true)}
        startIcon={
          <FontAwesomeIcon
            icon={faCheck}
            size="sm"
          />
        }
        size="small"
      >
        Review New User
      </Button>
    )
  }
  return (
    <Fragment>
      <Button
        color="primary"
        onClick={() => onEdit(record, false)}
        startIcon={<FontAwesomeIcon icon={faPencil} />}
        size="small"
      >
        Edit
      </Button>
      <UserAware
        render={(user) => (
          <Fragment>
            {(isUserPermitted || user.Id === record.Id) && (
              <Box
                borderLeft={1}
                borderColor="grey.300"
                component="span"
                ml={1}
                pl={1}
              >
                <Button
                  color="primary"
                  onClick={() => onRolesEdit(record)}
                  startIcon={<FontAwesomeIcon icon={faCog} />}
                  size="small"
                >
                  Roles
                </Button>
              </Box>
            )}
            {isUserPermitted && user.Id !== record.Id && (
              <Box
                color="error.dark"
                component="span"
                borderLeft={1}
                borderColor="grey.300"
                ml={1}
                pl={1}
              >
                <Button
                  color="inherit"
                  onClick={() => onDelete(record)}
                  startIcon={<FontAwesomeIcon icon={faTrash} />}
                  size="small"
                >
                  Delete
                </Button>
              </Box>
            )}
          </Fragment>
        )}
      />
    </Fragment>
  )
}

export default ActionsCell
